import React, { useState, useRef } from "react"
import { RxCaretDown } from "react-icons/rx"
import styles from "./CustomDropDown.module.scss"
// import PerfectScrollbar from "react-perfect-scrollbar"

const CustomDropdown = ({ title, options, Icon, onClick = () => {}, muted = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  // Close dropdown if clicked outside
  const closeDropdown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false)
    }
  }

  const handleOptionClick = (option) => {
    onClick(option);
    setIsOpen(false);
  };

  React.useEffect(() => {
    document.addEventListener("click", closeDropdown)
    return () => {
      document.removeEventListener("click", closeDropdown)
    }
  }, [])

  return (
    <div ref={dropdownRef} className={styles["dropdown-container"]}>
      <div className={styles["dropdown-toggle"]} onClick={toggleDropdown}>
        <div className="d-flex gap-1">
          {Icon && <span className={styles["icon-wrapper"]}>{Icon && <Icon size={20} />}</span>}
          <div className={`${muted && 'text-muted'}`}>{title}</div>
        </div>
        <span className={styles["icon-wrapper"]}>
          <RxCaretDown />
        </span>
      </div>

      {isOpen && (
        // <PerfectScrollbar className={styles["dropdown-menu"]} component="ul">
        <ul className={styles["dropdown-menu"]}>
          {options && options.length > 0 ? (
            options.map((option, index) => (
              <li key={index} className={styles["dropdown-item"]} onClick={() => handleOptionClick(option)}>
                {option}
              </li>
            ))
          ) : (
            <li className={styles["dropdown-item-no-options"]}>No Options</li>
          )}
        </ul>
        // </PerfectScrollbar>
      )}
    </div>
  )
}

export default CustomDropdown
